import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react'
import type { ReactNode} from 'react';
import { useEffect, useRef, useState } from 'react'
import type { CustomTooltipProps } from './CustomTooltip';
import CustomTooltip from './CustomTooltip'

export interface EllipsisProps extends BoxProps {
  children?: ReactNode
  tooltipProps?: Omit<CustomTooltipProps, 'children'>
  onEllipsisActiveChange?: (isEllipsisActive: boolean) => void
  disableTooltip?: boolean
}

export const Ellipsis = ({
  dangerouslySetInnerHTML,
  children,
  noOfLines,
  disableTooltip,
  tooltipProps,
  onEllipsisActiveChange,
  ...rest
}: EllipsisProps) => {
  const boxRef = useRef<HTMLDivElement>(null)
  const [isEllipsisActive, setIsEllipsisActive] = useState(false)

  useEffect(() => {
    const offsetHeight = boxRef.current?.offsetHeight ?? 0
    const scrollHeight = boxRef.current?.scrollHeight ?? 0

    const isEllipsisActive = offsetHeight < scrollHeight
    setIsEllipsisActive(isEllipsisActive)
  }, [setIsEllipsisActive])

  useEffect(() => {
    onEllipsisActiveChange?.(isEllipsisActive)
  }, [isEllipsisActive, onEllipsisActiveChange])

  return disableTooltip ? (
    <Box
      ref={boxRef}
      noOfLines={noOfLines ?? 1}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...rest}
    >
      {children}
    </Box>
  ) : (
    <CustomTooltip
      label={children || <Box dangerouslySetInnerHTML={dangerouslySetInnerHTML}></Box>}
      placement="bottom-start"
      trigger="clickHover"
      isDisabled={!isEllipsisActive}
      {...tooltipProps}
    >
      <Box
        ref={boxRef}
        noOfLines={noOfLines ?? 1}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...rest}
      >
        {children}
      </Box>
    </CustomTooltip>
  )
}
